import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["relevanceSelect", "customerSelect", "contentcategorySelect"]

  connect() {
    this.loadContentcategories()
  }

  relevanceChanged() {
    this.loadContentcategories()
  }

  customerChanged() {
    this.loadContentcategories()
  }

  loadContentcategories() {
    const relevance = this.relevanceSelectTarget.value
    const customerId = this.customerSelectTarget.value

    fetch(`/documents/filter_contentcategories?relevance=${relevance}&customer_id=${customerId}`)
      .then(response => response.json())
      .then(data => {
        this.contentcategorySelectTarget.innerHTML = ""

        const prompt = document.createElement("option")
        prompt.textContent = "Bitte wählen"
        prompt.value = ""
        this.contentcategorySelectTarget.appendChild(prompt)

        data.forEach((category) => {
          const option = document.createElement("option")
          option.textContent = category.name
          option.value = category.id
          this.contentcategorySelectTarget.appendChild(option)
        })
      })
  }
}
